import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const CounterList = styled(Box)({
  display: "flex",
  flexDirection: "column"
});

export const CounterRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  minHeight: "40px",
  borderBottom: `1px solid ${theme.palette.divider}`,
  "&:last-child": {
    borderBottom: "none"
  }
}));

export const CounterLabel = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "14px",
  fontWeight: 500
}));

export const CounterValueGroup = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px"
});

export const CounterValue = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
  fontWeight: 600,
  fontVariantNumeric: "tabular-nums"
}));

export const HistoryList = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minWidth: 0,
  marginTop: "20px",
  paddingTop: "16px",
  borderTop: `1px solid ${theme.palette.divider}`,
  gap: "8px"
}));
